<script setup lang="ts">
import type { CmsSectionDefault } from "@shopware/composables";
import { getCmsLayoutConfiguration } from "@shopware/helpers";

const props = defineProps<{
  content: CmsSectionDefault;
  class: any;
  style: any;
}>();

const { cssClasses, layoutStyles } = getCmsLayoutConfiguration(props.content);
</script>

<template>
  <CmsGenericBlock
      v-for="cmsBlock in content.blocks"
      :class="cssClasses"
      :style="layoutStyles"
      :key="cmsBlock.id"
      :content="cmsBlock"
  />
</template>
